import { SkeletonElement } from 'components/ui'

export function LoadingMobileRow() {
  return <SkeletonElement height='11.9rem' />
}
